import React from 'react';

import { SetPasswordForm } from './components/SetPasswordForm';

export const SetPassword: React.FC = () => <SetPasswordForm />
